'use client'

import useSWR from 'swr'
import { Card, CardContent } from '@/components/ui/card'
import apiService from '@/app/services/apiService'
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts'

export default function ContractsHistoryChart() {
  const { data, error, isLoading } = useSWR(
    '/api/contracts/history/',
    (url) => apiService.getWithToken(url)
  )

  if (isLoading) return <p>Carregando histórico...</p>
  if (error) return <p className="text-red-500">Erro ao carregar dados.</p>
  if (!data) return null

  const formattedData = data.map((item: any) => ({
    month: item.month.slice(0, 7), // yyyy-mm
    gross: item.total_gross,
    net: item.total_net
  }))

  return (
    <Card className="p-6 rounded-2xl shadow border">
      <div className='mb-4'>
        <h2 className="text-lg font-semibold mb-2">Evolução dos Contratos</h2>
        <p className="text-sm text-muted-foreground">
          Receita bruta e líquida mês a mês.
        </p>
      </div>
      <CardContent className="p-0">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={formattedData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="gross" stroke="#8884d8" name="Bruto" />
            <Line type="monotone" dataKey="net" stroke="#82ca9d" name="Líquido" />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}
